import EditOrDeleteBox, { EditOrDeleteBoxProps } from './EditOrDeleteBox';

export type { EditOrDeleteBoxProps };
export default EditOrDeleteBox;
